import { render, staticRenderFns } from "./PanelPreviewData.vue?vue&type=template&id=6e75e2e1&scoped=true"
import script from "./PanelPreviewData.vue?vue&type=script&lang=js"
export * from "./PanelPreviewData.vue?vue&type=script&lang=js"
import style0 from "./PanelPreviewData.vue?vue&type=style&index=0&id=6e75e2e1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e75e2e1",
  null
  
)

export default component.exports
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBadge,QBtn});
